import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const YeloCardIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 52 34" sx={{ height: '34px', width: '52px', ...sx }} {...props}>
      <g clipPath="url(#clip0_2436_4525)">
        <rect y="0.900391" width="52" height="32.5" rx="2.36364" fill="#051F36" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.738 -4.74414L-14.2144 -15.9995L-24.7 33.3317L28.2524 44.587L30.2628 35.1288L38.738 -4.74414Z"
          fill="#FFC72C"
        />
        <path
          d="M48.6287 28.2441V28.0903H48.5884L48.5418 28.196L48.4955 28.0903H48.455V28.2441H48.4836V28.1281L48.5272 28.2283H48.5568L48.6003 28.1279V28.2441H48.6287ZM48.3732 28.2441V28.1165H48.4249V28.0905H48.2932V28.1165H48.3449V28.2441H48.3732Z"
          fill="#F79410"
        />
        <path d="M44.0513 28.9063H40.5671V22.668H44.0513V28.9063Z" fill="#FF5F00" />
        <path
          d="M40.7902 25.7865C40.7902 24.521 41.385 23.3938 42.3111 22.6673C41.6338 22.1361 40.7791 21.819 39.8502 21.819C37.6511 21.819 35.8684 23.5953 35.8684 25.7865C35.8684 27.9777 37.6511 29.7539 39.8502 29.7539C40.7791 29.7539 41.6338 29.4368 42.3111 28.9056C41.385 28.1792 40.7902 27.0519 40.7902 25.7865Z"
          fill="#EB001B"
        />
        <path
          d="M48.7501 25.7865C48.7501 27.9777 46.9674 29.7539 44.7683 29.7539C43.8394 29.7539 42.9846 29.4368 42.3071 28.9056C43.2335 28.1792 43.8282 27.0519 43.8282 25.7865C43.8282 24.521 43.2335 23.3938 42.3071 22.6673C42.9846 22.1361 43.8394 21.819 44.7683 21.819C46.9674 21.819 48.7501 23.5953 48.7501 25.7865Z"
          fill="#F79E1B"
        />
      </g>
      <defs>
        <clipPath id="clip0_2436_4525">
          <rect y="0.900391" width="52" height="32.5" rx="2.36364" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default YeloCardIcon;
